import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  InventarioIA,
  InventarioIAReq,
  InventarioIARes,
} from "../shared/model/iso42001/inventario-ia.model";

@Injectable({
  providedIn: "root",
})
export class InventarioIAService {
  constructor(private http: HttpClient) {}

  consultar(filtro?: InventarioIA): Observable<InventarioIARes> {
    const req: InventarioIAReq = { filtro };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_CONSULTAR,
      req,
    );
  }

  obtener(idInventarioIa: number): Observable<InventarioIARes> {
    const req: InventarioIAReq = { idInventarioIa };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_OBTENER,
      req,
    );
  }

  guardar(inventario: InventarioIA): Observable<InventarioIARes> {
    const req: InventarioIAReq = { inventario };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_GUARDAR,
      req,
    );
  }

  actualizar(inventario: InventarioIA): Observable<InventarioIARes> {
    const req: InventarioIAReq = { inventario };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_ACTUALIZAR,
      req,
    );
  }

  cambiarEstatus(
    idInventarioIa: number,
    estatus: string,
  ): Observable<InventarioIARes> {
    const req: InventarioIAReq = { idInventarioIa, estatus };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_ESTATUS,
      req,
    );
  }

  /** Borrado físico e irreversible: elimina el activo, sus impactos y su bitácora. */
  eliminar(idInventarioIa: number): Observable<InventarioIARes> {
    const req: InventarioIAReq = { idInventarioIa };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_ELIMINAR,
      req,
    );
  }

  historial(idInventarioIa: number): Observable<InventarioIARes> {
    const req: InventarioIAReq = { idInventarioIa };
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_INVENTARIO_HISTORIAL,
      req,
    );
  }

  ciclosVida(): Observable<InventarioIARes> {
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_CAT_CICLO_VIDA,
      {},
    );
  }

  nivelesSupervision(): Observable<InventarioIARes> {
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_CAT_NIVEL_SUPERVISION,
      {},
    );
  }

  tiposImpacto(): Observable<InventarioIARes> {
    return this.http.post<InventarioIARes>(
      UrlConstantes.ISO42001_CAT_TIPO_IMPACTO,
      {},
    );
  }

  /** Catálogo de áreas dedicado del inventario de IA (iso42001_cat_area). */
  catAreas(): Observable<InventarioIARes> {
    return this.http.post<InventarioIARes>(UrlConstantes.ISO42001_CAT_AREA, {});
  }
}
